import { render, staticRenderFns } from "./SyncImage.vue?vue&type=template&id=1248686e&"
import script from "./SyncImage.vue?vue&type=script&lang=ts&"
export * from "./SyncImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports